import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationOverlay = _resolveComponent("ConfirmationOverlay")!

  return (_openBlock(), _createBlock(_component_ConfirmationOverlay, {
    acceptTheme: "primary",
    titleText: _ctx.companyMismatchTitle,
    subtitleText: `Trailer #${_ctx.trailerNumber}`,
    subtitleStyle: "strong-subtitle",
    acceptText: "Back to Scan",
    rejectText: "",
    onAccept: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onBackToScan'))),
    image: _ctx.trailerCompany,
    includeReturnDeepLink: false
  }, null, 8, ["titleText", "subtitleText", "image"]))
}